// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
  NumberInput,
  NumberField
} from "react-admin";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const AutocompleteFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput source="search_field" alwaysOn />

  </Filter>
);

export const AutocompleteList = (props) => (
  <List {...props} filters={<AutocompleteFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="search_field" />
      <NumberField source="priority" label="Priorité" />
      <TextField source="description" />
      <TextField source="province" />
      <TextField source="Commune" />


      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const AutocompleteShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="search_field" label="Recherche" />
      <TextField source="priority" label="Priorité" />
      <TextField source="description" />
      <TextField source="province" />
      <TextField source="Commune" />

    </SimpleShowLayout>
  </Show>
);

export const AutocompleteEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      {/* <TextInput source="id" /> */}
      <TextInput source="search_field" label="Recherche" />
      <NumberInput source="priority" label="Priorité" />
      <TextInput source="description" />
      <TextField source="province" />
      <TextField source="Commune" />

    </SimpleForm>
  </Edit>
);
